<template>
  <v-container v-if="offer" :loading="loading">
    <v-tabs v-model="tab">
      <v-tab href="#main">
        Übersicht
      </v-tab>
      <v-tab href="#status">
        Status
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item id="main">
        <order-overview
          :overview="overview"
          :offer-data="offer.get_data"
          :offer="offer"
          :editable="false"
        />
        <v-container fluid>
          <v-row justify="end">
            <v-btn
              color="primary"
              :href="route('offer.stueckliste', offer.id)"
              style="margin-right: 2px"
            >
              Download Stückliste
            </v-btn>
            <order-export :orderid="offer.get_data.id" :termid="offer.term_id" />
            <v-btn
              color="primary"
              :href="
                route('offerData.download', {
                  offerData: offer.get_data.id,
                  term: offer.term_id,
                  view: 'vorleister',
                  full: true,
                })
              "
              style="margin-left: 2px"
              target="_blank"
            >
              Vorleister Angebot
            </v-btn>

            <v-dialog v-model="contractDialog" persistent max-width="290">
              <template #activator="{ on }">
                <v-btn color="primary" dark style="margin-left: 2px" v-on="on">
                  Vertrag erstellen
                </v-btn>
              </template>
              <v-card>
                <v-card-title class="headline">
                  Vertragszeitraum eingeben
                </v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col cols="12">
                      <v-menu
                        ref="startDateMenu"
                        v-model="startDateMenu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template #activator="{ on, attrs }">
                          <v-text-field
                            v-model="startDate"
                            label="Startdatum"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                          />
                        </template>
                        <v-date-picker
                          v-model="startDate"
                          :active-picker.sync="startDateActivePicker"
                          :max="
                            new Date(
                              new Date().setMonth(new Date().getMonth() + 6)
                            )
                              .toISOString()
                              .substr(0, 10)
                          "
                          :min="
                            new Date(
                              new Date().setMonth(new Date().getMonth() - 6)
                            )
                              .toISOString()
                              .substr(0, 10)
                          "
                        />
                      </v-menu>
                    </v-col>
                    <v-col cols="12">
                      <v-menu
                        ref="endDateMenu"
                        v-model="endDateMenu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template #activator="{ on, attrs }">
                          <v-text-field
                            v-model="endDate"
                            label="Enddatum"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                          />
                        </template>
                        <v-date-picker
                          v-model="endDate"
                          :active-picker.sync="endDateActivePicker"
                          :max="
                            new Date(
                              new Date().setMonth(new Date().getMonth() + 66)
                            )
                              .toISOString()
                              .substr(0, 10)
                          "
                          :min="new Date().toISOString().substr(0, 10)"
                        />
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="primary"
                    flat
                    @click.native="contractDialog = false"
                  >
                    Abbrechen
                  </v-btn>
                  <v-btn color="primary" @click="makeContract">
                    speichern
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
        </v-container>
      </v-tab-item>
      <v-tab-item id="status">
        <v-container fluid>
          <v-row>
            <v-col>
              <v-btn class="m-0" @click="dialog = true">
                Status ändern
              </v-btn>
            </v-col>
            <statuswahl
              :offer="offer"
              :offerstatus="offerstati"
              :opened="dialog"
              @close="dialog = false"
            />
          </v-row>
          <v-timeline dense clipped>
            <v-slide-x-transition group>
              <template v-for="(status, index) in offer.offer_status">
                <v-timeline-item :key="status.pivot.id" class="mb-4">
                  <v-row justify="space-between">
                    <v-col cols="7">
                      Status
                      <v-chip
                        class="white--text ml-0"
                        color="primary"
                        label
                        v-text="status.status_code"
                      />
                      <span v-text="status.title" />
                    </v-col>
                    <v-col
                      class="text-right"
                      cols="5"
                      v-text="getDateString(status.pivot.created_at)"
                    />
                  </v-row>
                </v-timeline-item>

                <v-timeline-item
                  v-if="index === 0"
                  :key="index"
                  color="grey"
                  icon-color="grey lighten-2"
                  large
                >
                  <v-row>
                    <v-col>Kommentar hinzufügen:</v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="2">
                      <v-text-field
                        v-model="commentInput.label"
                        hide-details
                        flat
                        label="Label"
                      />
                    </v-col>
                    <v-col cols="8">
                      <v-text-field
                        v-model="commentInput.text"
                        hide-details
                        flat
                        label="Text"
                      />
                    </v-col>
                    <v-col>
                      <v-btn class="m-0" depressed @click="comment">
                        Speichern
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-timeline-item>

                <v-timeline-item
                  v-for="data in status.pivot.data"
                  :key="data.id"
                  class="mb-4"
                  color="grey"
                  icon-color="grey lighten-2"
                  small
                >
                  <v-row justify="space-between">
                    <v-col cols="2">
                      <v-chip
                        class="white--text ml-0"
                        color="grey"
                        label
                        v-text="data.key"
                      />
                    </v-col>
                    <v-col>
                      <span v-text="data.value" />
                    </v-col>
                    <v-col
                      class="text-right"
                      cols="2"
                      v-text="getDateString(data.created_at)"
                    />
                  </v-row>
                </v-timeline-item>
              </template>
            </v-slide-x-transition>
          </v-timeline>
        </v-container>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Default'
import { formattedDateTimeString } from '@/plugins/formatDate.js'

export default {
   metaInfo () {
      // don't know your return object structure,
      // maybe you should check whole this.getViewPage
      return {
         title: this.title ? this.title : `Angebot ${this.offer.id}`,
      }
   },
   layout: (h, page) => h(Layout, [page]),

   props: {
      offer: {
         type: Object,
         required: true,
      },
      overview: {
         type: Object,
         required: true,
      },
      offerstati: {
         type: Array,
         required: true,
      },
   },
   data () {
      return {
         contractDialog: false,
         dialog: false,
         loading: true,
         tab: 'main',
         commentInput: {
            label: '',
            text: '',
         },
         startDateActivePicker: 'MONTH',
         endDateActivePicker: 'YEAR',
         startDateMenu: false,
         endDateMenu: false,
         startDate: null,
         endDate: null,
      }
   },
   watch: {
      startDateMenu (val) {
         val && setTimeout(() => (this.startDateActivePicker = 'MONTH'))
      },
      endDateMenu (val) {
         val && setTimeout(() => (this.endDateActivePicker = 'YEAR'))
      },
   },
   methods: {
      async comment () {
         this.$inertia.post(
            `/offer/${this.offer.id}/status/${this.offer.offer_status[0].pivot.id}/comment`,
            this.commentInput,
            {
               onSuccess: (page) => {
                  page.$inertia.reload({ only: ['offerstati'] })
                  console.log('success')
               },
            }
         )
      },
      makeContract () {
         this.$inertia.post(this.route('contract.store'), {
            offer: this.offer.id,
            startDate: this.startDate,
            endDate: this.endDate,
         })
      },
      getDateString (dateVal) {
         return formattedDateTimeString(dateVal)
      },
      downloadStueckliste () {
         this.$inertia.visit()
      },
   },
}
</script>
